module.exports = __webpack_public_path__ + "static/img/calogero.ed4930a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other_supporters/calogero.png
// module id = fh64
// module chunks = 1